<template>
  <v-row
    no-gutters
    class="appBar"
    role="banner"
    aria-label="Logo przekierowujące do strony głównej Usteckiej Karty Mieszkańca"
  >
    <logo />
  </v-row>
</template>

<script>
import Logo from '@/components/material/Logo';

// @vuese
// Uproszczony nagłówek strony
// @group MainLayout
export default {
  components: { Logo }
};
</script>
